/* src/app/modules_v2/finance/credit-shared/styles/credit-dialog.scss */
.cr-header-text {
  min-width: 0;
  padding-right: 32px;
}
.cr-body {
  padding: 0 !important;
}
.cr-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-bottom: 1px solid #e5f3a0;
}
.cr-summary__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.cr-summary__icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cr-summary__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #1a1d23;
}
.cr-summary__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
}
.cr-summary__amount {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.cr-summary__hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
.cr-summary__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.cr-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.cr-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.cr-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.cr-section__hint {
  font-size: 12px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
}
.cr-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
  cursor: pointer;
}
.cr-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.cr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.cr-grid__wide {
  grid-column: 1/-1;
}
.cr-suffix {
  font-size: 14px;
  color: #6b7280;
  margin-right: 6px;
}
.cr-info,
.cr-empty {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.cr-info mat-icon,
.cr-empty mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.cr-empty--error mat-icon,
.cr-error mat-icon {
  color: #dc2626;
}
.cr-error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  font-size: 13px;
  color: #b91c1c;
}
.cr-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.cr-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.cr-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.cr-row--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.cr-row__main {
  flex: 1;
  min-width: 0;
}
.cr-row__amount {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.cr-row__meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cr-row__date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
.cr-row__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.cr-row__btn {
  width: 32px;
  height: 32px;
  padding: 4px;
  color: #6b7280 !important;
}
.cr-row__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cr-row__btn--danger:hover {
  color: #dc2626 !important;
}
.cr-upload-input {
  display: none;
}
.cr-upload {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin: 8px 0 12px;
}
@media (max-width: 600px) {
  .cr-summary {
    flex-direction: column;
    align-items: flex-start;
  }
  .cr-row {
    flex-wrap: wrap;
  }
}
/*# sourceMappingURL=credit-dialog.css.map */
